import styled from 'styled-components';
import { detailsBackground, textGrey } from '../../config/colors';
import { ReactComponent as WeightIconSvg } from '../../resources/weight.svg';
import { ReactComponent as DimenssionsIconSvg } from '../../resources/dimensions.svg';

export const PhysicalWrapper = styled.div`
  background-color: ${detailsBackground};
  padding-left: 5px;
  padding-top: 10px;
  padding-bottom: 5px;
  margin-top: 5px;
  margin-bottom: 5px;
  height: 65px;
  border-radius: 3px;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const WeightIcon = styled(WeightIconSvg)`
  width: 22px;
  height: 22px;
  margin-left: 10px;
`;

export const DimenssionsIcon = styled(DimenssionsIconSvg)`
  width: 22px;
  height: 22px;
  margin-top: 3px;
  transform: rotate(180deg);
  margin-left: 30px;
`;

export const DimenssionsText = styled.p`
  font-size: 1rem;
  font-weight: 500;
  color: ${textGrey};
  margin-left: 15px;
`;
